import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { isAuthenticated } from '../services/authService';
import { useUser } from '../contexts/UserContext';

const ProtectedRoute = ({ children }) => {
  const { loadingUser } = useUser();
  const [isLoadingTimeout, setIsLoadingTimeout] = useState(false);

  console.log('ProtectedRoute: loadingUser:', loadingUser);
  
  // useEffect(() => {
  //   const timeout = setTimeout(() => {
  //     if (loadingUser) {
  //       console.warn('ProtectedRoute: loadingUser state is taking too long. Forcing redirection check.');
  //       setIsLoadingTimeout(true);
  //     }
  //   }, 5000); // 5-second timeout

  //   return () => clearTimeout(timeout);
  // }, [loadingUser]);

  // if (loadingUser && !isLoadingTimeout) {
  //   console.log('ProtectedRoute: User data is still loading.');
  //   return null; // Optionally, render a loader here
  // }

  if (!isAuthenticated()) {
    console.warn('ProtectedRoute: User is not authenticated. Redirecting to login.');
    return <Navigate to={`/login`} />;
  }

  return children;
};

export default ProtectedRoute;